/** @format */

import Accordion from "../../../../shared/components/accordion";
import QuoteStep from "../../enums/QuoteStep";
import useQuoteStore from "../../store/QuoteStore";
import usePanelStore from "../../store/PanelStore";
import { useState } from "react";
import useAppStateStore from "../../../../shared/store/AppStateStore";

const TqPanelMemberFeatures = () => {
  const STATE = useAppStateStore();
  const quoteStore = useQuoteStore.getState();
  const { get: getPanelData } = usePanelStore();
  const panelQuoteData = getPanelData()?.panelData;
  const [triggerRender, setTriggerRender] = useState(0);

  if (!STATE.featuresModal) return null;

  const coverTypeMap = {
    "01": "Comprehensive",
    "02": "Third Party and Theft",
    "03": "Third Party Only",
  };

  const quoteRef = panelQuoteData.quoteReference ?? "";
  const coverTypeId = quoteStore.quote.risk.vehicles[0].coverTypeId;
  const coverType = coverTypeMap[coverTypeId] || coverTypeId; // Fallback to ID if mapping not found
  const voluntary = quoteStore.quote.risk.cover.requestedVolExcess;
  const compulsory =
    STATE.selectedCard.panelMemberQuoteExcesses[2]?.excessAmount || 0; // Handle undefined index
  const totalExcess = voluntary + compulsory;

  const policyDetailsString = localStorage.getItem("policyDetails");
  const policyDetails = policyDetailsString
    ? JSON.parse(policyDetailsString)
    : null;

  let filteredSchemes;
  if (policyDetails?.uberpolicies?.AllSchemeFeatureDescriptions) {
    const scehemes = policyDetails.uberpolicies?.AllSchemeFeatureDescriptions;
    filteredSchemes = policyDetails.uberpolicies?.AllSchemeFeatureDescriptions.filter(
      (item) =>
        item.schemeFeatureDescriptionKey.startsWith(
          STATE.selectedCard.schemeTableId
        )
    );
  } else {
    console.error(
      "PolicyDetails or AllSchemeFeatureDescriptions is missing or undefined"
    );
  }

  const categorizedFeatures = {
    QuoteFeature: [],
    ImportantTerm: [],
  };

  const filteredFeatures = filteredSchemes?.filter((feature) =>
    ["QuoteFeature", "ImportantTerm"].includes(feature?.category)
  );

  filteredFeatures?.forEach((feature) => {
    const category = feature?.category;
    if (categorizedFeatures[category]) {
      categorizedFeatures[category]?.push(feature);
    }
  });

  const closeMoreInfoModal = () => {
    STATE.setSelectedCard(null);
    STATE.setFeaturesModal(false);
  };

  return (
    <>
      {STATE.featuresModal && STATE.selectedCard && (
        <div className="">
          <div className="">
            <div
              className="grayedOutBgFixed"
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  closeMoreInfoModal();
                  setTriggerRender((prev) => prev + 1);
                }
              }}
            ></div>

            <>
              {STATE.currentStep === QuoteStep.TQ_PANEL ? (
                <div className="FeaturesModelMainBody">
                  <div
                    id="myModal"
                    className={`${
                      STATE.featuresModal === true ? "modal" : "add"
                    } `}
                  >
                    <div className="features-modal-content featuresModelScroll">
                      <div className="info-modal-header">
                        <h1>Quote Details</h1>
                        <span
                          onClick={closeMoreInfoModal}
                          className="info-close"
                        >
                          &times;
                        </span>
                      </div>
                      <div className="info-modal-body container">
                        <div className="quote-detail2 gray-text font-14">
                          <span className="font-14">Cover type</span>
                          <span className="font-14">{coverType}</span>
                        </div>
                        <div className="quote-detail2 gray-text font-14 margin-bottom-25">
                          <span className="font-14">Quote reference</span>
                          <span className="font-14">{quoteRef}</span>
                        </div>

                        <h5 className="font-16 font-black margin-y-axis-15 margin-bottom-05 margin-top-0">
                          Excess
                        </h5>
                        <div className="quote-detail2 gray-text font-14">
                          <span className="font-14">Voluntary</span>
                          <span className="font-14">£{voluntary}</span>
                        </div>
                        <div className="quote-detail2 gray-text font-14">
                          <span className="font-14">Compulsory</span>
                          <span className="font-14">£{compulsory}</span>
                        </div>
                        <div className="quote-detail2 gray-text">
                          <span className="font-14">Total Excess</span>
                          <span className="font-14">£{totalExcess}</span>
                        </div>

                        <div className="">
                          {/* Render categorized features */}
                          {categorizedFeatures["QuoteFeature"].length > 0 && (
                            <Accordion
                              title="Quote Features"
                              items={categorizedFeatures["QuoteFeature"]}
                            />
                          )}
                          {categorizedFeatures["ImportantTerm"].length > 0 && (
                            <Accordion
                              title=""
                              items={categorizedFeatures["ImportantTerm"]}
                            />
                          )}
                        </div>
                      </div>
                      <div className="modal-footer"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </>
          </div>
        </div>
      )}
    </>
  );
};

export default TqPanelMemberFeatures;
